import React, { FC, useCallback } from 'react';

import { AgentStatusCondition as AgentStatusConditionType, AgentStatusType } from 'src/actions/rules/condition';
import ConditionRow from './ConditionRow';
import { StyledDropdown } from 'src/presentation/components/pages/rules/shared/StyledComponents';

type AgentStatusConditionProps = {
  condition: AgentStatusConditionType;
  index: number;
  onDelete: Function;
  onUpdate: Function;
};

const AgentStatusCondition: FC<AgentStatusConditionProps> = ({ condition, index, onDelete, onUpdate }) => {
  const onStatusChange = useCallback(
    val => {
      condition.setValue(val);
      onUpdate({ condition, index });
    },
    [condition, index, onUpdate]
  );
  return (
    <ConditionRow index={index} onDelete={onDelete} text="Agent status is">
      <StyledDropdown onSelect={onStatusChange} options={statusOptions} value={condition.value} />
    </ConditionRow>
  );
};

const statusOptions: { label: string; value: string }[] = [
  { label: 'Away', value: AgentStatusType.Away },
  { label: 'Offline', value: AgentStatusType.Offline },
];

export default AgentStatusCondition;
